import React from 'react'
import MainLayout from 'layout/MainLayout'
const SuperuserDashboard = () => {
	return <MainLayout title='SUPERUSER DASHBOARD'></MainLayout>
}

export default SuperuserDashboard
